export default class BaseMovement {
    constructor(entity, position) {
        this.Entity = entity;
        this.Position = position;

        this.cancellToken = {};
        this.IsCancelled = false;
    }
    
    Play(gameSpeed) {

    }

    Cancell() {
        if(this.cancellToken.cancel != null){
            this.cancellToken.cancel(); 
        }
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/Animations/Movements/Base.js
 **/